import { render, staticRenderFns } from "./ModalGerarCobranca.vue?vue&type=template&id=24a611f2&"
import script from "./ModalGerarCobranca.vue?vue&type=script&lang=js&"
export * from "./ModalGerarCobranca.vue?vue&type=script&lang=js&"
import style0 from "./ModalGerarCobranca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports